import { PaymentWidget } from "./PaymentWidget";
import api from "../../api";

export class StripeWidget extends PaymentWidget {
    stripe = null;
    elements = null;
    paymentElement = null;
    scriptGlobalVar = "Stripe";


    init() {
        if (this.initialized) return;
        this.setupBfCacheReload();
        this.loadExternalScript("https://js.stripe.com/v3/")
            .then(() => {
                this.setupPaymentButton();
                super.init();
            })
            .catch((error) => {
                this.error({
                    error: "Ошибка при загрузке платежной системы",
                    details: error?.message || "Не удалось загрузить скрипт Stripe",
                });
            });
    }


    setupPaymentButton() {
        this.find("#customPayButton")?.addEventListener("click", () =>
            this.handleSubmit()
        );
    }

    /**
     * Redirect-методы (Klarna и т.п.) уводят со страницы прямо во время handleSubmit,
     * поэтому кнопка остаётся скрытой. Возврат кнопкой «Назад» достаёт страницу из bfcache
     * вместе с этим состоянием — перезагружаем, чтобы получить актуальный инвойс и рабочую форму.
     */
    setupBfCacheReload() {
        window.addEventListener("pageshow", (event) => {
            if (event.persisted) {
                window.location.reload();
            }
        });
    }

    /** Нейтральное сообщение под формой — для статусов, которые не отказ и не успех */
    showNotice(message) {
        const el = this.find("#customPaymentMessage");
        if (!el) return;

        el.textContent = message;
        el.style.color = "inherit";
        el.style.display = "block";
    }

    async show() {
        await this.initializeStripe(this.paymentData);
    }

    async initializeStripe({ secret_key_payment }) {
        console.log(this.paymentData, secret_key_payment)

        // Проверка наличия secret_key_payment
        if (!secret_key_payment) {
            console.error('secret_key_payment отсутствует в paymentData', this.paymentData);
            this.error({
                error: "Не удалось инициализировать платежную систему. Отсутствует необходимый ключ для оплаты."
            });
            return;
        }

        try {
            this.stripe = Stripe(window.app.payments.stripe.client_id);
            this.elements = this.stripe.elements({
                clientSecret: secret_key_payment,
                appearance: {
                    theme: "flat",
                    variables: { colorPrimaryText: "#2932FF" },
                },
                locale: this.paymentData.language,
            });
            this.setupPaymentElement();
        } catch (error) {
            console.error('Ошибка при инициализации Stripe Elements', error);
            this.error({
                error: "Не удалось инициализировать платежную систему. Попробуйте обновить страницу."
            });
        }
    }

  setupPaymentElement() {
    this.paymentElement?.unmount();
    this.paymentElement = this.elements.create("payment");
    this.paymentElement.mount("#customStripePaymentContent");
    const payButton = this.find("#customPayButton");
    payButton.style.display = "block";
    payButton.disabled = true;


    this.paymentElement.on('change', (event) => {
        if (event.complete) {
            payButton.disabled = false;
            // this.clearError();
        } else {
            payButton.disabled = true;
        }
        if (event.error) {
            this.showError(event.error.message);
        } else {
            // this.clearError();
        }
    });
}


    async handleSubmit() {
        this.setLoadingState(true);
        try {
            const { error: validationError } = await this.elements.submit();
            if (validationError) {
                return;
            }

            // Проверка, является ли это подпиской
            const isRecurring = this.paymentData.is_recurring || this.paymentData.subscription_id;

            const { error, paymentIntent } = await this.stripe.confirmPayment({
                elements: this.elements,
                confirmParams: {
                    return_url: this.paymentData.links.return || this.paymentData.links.callback,
                },
                redirect: "if_required",
            });

            if (error) {
                this.showError(error.message);
                return;
            }

            // Асинхронные методы (SEPA, ACH и т.п.) списывают деньги не сразу: статус
            // processing — это не отказ, финальный придёт вебхуком. Ошибку показывать нельзя.
            if (paymentIntent?.status === "processing") {
                this.showNotice(this.pending_message || "Payment is being processed");
                return;
            }

            // Успех показываем только при реально прошедшем платеже. Иначе (закрытая модалка
            // WeChat, брошенная 3DS и т.п.) Stripe возвращает интент в промежуточном статусе,
            // и рисовать «Оплата прошла успешно» нельзя.
            if (!paymentIntent || paymentIntent.status !== "succeeded") {
                this.showError(this.not_completed_message || "Payment was not completed");
                return;
            }

            if (isRecurring) {
                await this.captureSubscription(paymentIntent.id);
            } else {
                await this.capturePayment(paymentIntent.id);
            }

            super.success(paymentIntent);
        } catch (error) {
            console.error(error);
            this.error({ error: "Произошла ошибка" });
        } finally {
            this.setLoadingState(false);
        }
    }

    async capturePayment(paymentIntentId) {
        try {
            await api.post(`/payment/stripe/capture/${this.paymentData.invoice}`,{ payment_intent: paymentIntentId });
        } catch (err) {
            console.error(err);
            this.error({ error: 'Произошла ошибка' });
        }
    }

    async captureSubscription(subscriptionId) {
        try {
            await api.post(`/payment/stripe/capture/${this.paymentData.invoice}`,{
                subscription_id: subscriptionId,
                is_recurring: true
            });
        } catch (err) {
            console.error(err);
            this.error({ error: 'Произошла ошибка при создании подписки' });
        }
    }
}
